import ArticleLayout from "@/components/feature/ArticleLayout";
import { articles } from "@/mocks/articles";

const article = articles[7];

export default function Artigo() {
  return (
    <ArticleLayout
      title={article.title}
      description={article.excerpt}
      date={article.date}
      readTime={article.readTime}
      imageUrl={article.imageUrl}
      keywords="comprar da China, como comprar China CSSBuy, importar China Portugal, compras China guia"
      articleSchemaName="CSSBuy Spreadsheet"
      faqItems={article.faq}
    >
      <p>
        Comprar da China nunca foi tão acessível como em 2026. Com o CSSBuy e a nossa <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow">planilha de produtos</a>, podes importar praticamente tudo: roupa, calçado, acessórios, eletrónica e muito mais. Este guia cobre todo o processo.
      </p>

      <h2>Porquê Comprar da China?</h2>
      <p>
        A China é a fábrica do mundo. Os preços de produção são significativamente mais baixos, o que se reflete no preço final. Comprando diretamente de plataformas chinesas através de um agente como o CSSBuy, eliminas intermediários e poupas entre 40% a 70% em comparação com lojas locais.
      </p>

      <h2>Plataformas Chinesas Suportadas</h2>
      <p>
        O CSSBuy suporta as principais plataformas de ecommerce chinesas:
      </p>
      <ul>
        <li><strong>Taobao</strong>: o maior marketplace da China, equivalente ao eBay/Amazon</li>
        <li><strong>Weidian</strong>: plataforma focada em moda e streetwear, preços muito competitivos</li>
        <li><strong>1688</strong>: plataforma de atacado, ideal para compras em quantidade</li>
        <li><strong>Tmall</strong>: lojas oficiais de marcas, produtos autênticos</li>
      </ul>

      <h2>Processo de Compra Simplificado</h2>
      <p>
        O processo com o CSSBuy é simples: encontras o produto (usa a <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow">nossa planilha</a>), copias o link, colas no CSSBuy, selecionas opções, pagas, recebes QC, aprovas e escolhes o envio. Não precisas de falar chinês nem de ter conta nas plataformas chinesas.
      </p>

      <h2>Custos de Envio para Portugal</h2>
      <p>
        Os custos de envio variam conforme peso e método. Para referência: um par de ténis (cerca de 1.5kg) custa entre €20 e €35 de frete para Portugal. Uma encomenda de 5kg custa entre €50 e €80. Recomendamos usar EUB para pacotes pequenos (mais barato) e EMS/DHL para entregas rápidas.
      </p>

      <h2>Alfândega e Taxas</h2>
      <p>
        Para Portugal, encomendas abaixo de €22 podem estar isentas de IVA (embora as regras da UE tenham mudado). O CSSBuy permite personalizar a declaração aduaneira, e recomendamos declarar valores realistas para evitar problemas. Pacotes declarados abaixo de €20 raramente são taxados.
      </p>
    </ArticleLayout>
  );
}